import React from "react";

const ShipmentStatusModalSkeleton = () => {
  return (
    <>
      {" "}
      <div className="w-3/5 h-8 mb-4 bg-ui-border animate-pulse rounded-md" />
      <div className="w-full h-10 bg-ui-border animate-pulse rounded-md" />
      <div className="w-1/3 h-5 mt-4 mb-2 bg-ui-border animate-pulse rounded-md" />
      <div className="w-full h-7  mb-2 bg-ui-border animate-pulse rounded-md" />
      <div className="flex w-full justify-end pt-2 mt-2 border-t border-ui-border space-x-2">
        <div className="h-8 w-16 bg-ui-border animate-pulse rounded-md" />
        <div className="h-8 w-16 bg-ui-border animate-pulse rounded-md" />
      </div>
    </>
  );
};

export default ShipmentStatusModalSkeleton;
